import {
    ROLE,
    SALE_ORDER_STATUS,
    SALE_ORDER_TYPE,
} from "../../../data/enums";

const SALE_ORDER_EDIT_ROLES: ROLE[] = [
    ROLE.MANAGER,
    ROLE.SALE_MANAGER,
    ROLE.LOGISTIC_MANAGER,
    ROLE.SALE_STAFF,
    ROLE.PRODUCTION_STAFF,
];

const SALE_ORDER_CANCEL_ROLES: ROLE[] = [
    ROLE.MANAGER,
    ROLE.SALE_STAFF,
    ROLE.PRODUCTION_STAFF,
    ROLE.LOGISTIC_MANAGER,
];

const SALE_ORDER_CANCELLABLE_STATUSES: SALE_ORDER_STATUS[] = [
    SALE_ORDER_STATUS.OPEN,
    SALE_ORDER_STATUS.LOGISTIC_REVIEWED,
    SALE_ORDER_STATUS.MATERIAL_REQUESTED_AND_MANUFACTURING,
    SALE_ORDER_STATUS.IMPORTING_AND_EXPORTING,
];

export const hasDepartedDeliveryTrip = (deliveryTrips: any[] = []) =>
    deliveryTrips.some((trip: any) => {
        const status = String(trip?.status || "").toUpperCase();
        return Boolean(
            trip?.is_first_storage_keeper_exported ||
            trip?.is_second_storage_keeper_exported ||
            trip?.is_exported ||
            trip?.departure_at ||
            status === "IN_TRANSIT" ||
            status === "DELIVERED" ||
            status === "RETURNED",
        );
    });

export const getSaleOrderEditCapabilities = ({
    role,
    status,
    deliveryTrips,
    orderType = SALE_ORDER_TYPE.SALE,
}: {
    role: ROLE;
    status?: string;
    deliveryTrips?: any[];
    orderType?: string;
}) => {
    const normalizedStatus = String(status || "").toUpperCase();
    const isTerminal = [
        SALE_ORDER_STATUS.COMPLETED,
        SALE_ORDER_STATUS.CANCELLED,
    ].includes(normalizedStatus as SALE_ORDER_STATUS);
    const canUseEditApi = SALE_ORDER_EDIT_ROLES.includes(role);
    const hasDepartedTrip = hasDepartedDeliveryTrip(deliveryTrips);
    const canEditNotes = canUseEditApi && !isTerminal;
    const canShowCancelOrder =
        orderType === SALE_ORDER_TYPE.SALE &&
        SALE_ORDER_CANCEL_ROLES.includes(role) &&
        SALE_ORDER_CANCELLABLE_STATUSES.includes(
            normalizedStatus as SALE_ORDER_STATUS,
        );

    return {
        canEditNotes,
        canEditFullOrder: canEditNotes && !hasDepartedTrip,
        hasDepartedTrip,
        canShowCancelOrder,
        canCancelOrder: canShowCancelOrder && !hasDepartedTrip,
    };
};
